import { useState, useRef, useEffect, useCallback } from 'react';
import imgCreate from '../../../../images/hero.jpg';
import imgGuests from '../../../../images/birthday.jpg';
import imgShare from '../../../../images/Wedding.jpg';
import './Features.css';

const cards = [
  {
    image: imgCreate,
    title: 'Create Events',
    description: 'Set up your event with date, time, and location in minutes',
  },
  {
    image: imgGuests,
    title: 'Manage Guests',
    description: 'Add guests, track RSVPs, and keep everyone updated',
  },
  {
    image: imgShare,
    title: 'Share Easily',
    description: 'Send beautiful invitations via WhatsApp or shareable links',
  },
  
];

function Features() {
  const trackRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isOverflow, setIsOverflow] = useState(false);

  const checkOverflow = useCallback(() => {
    const track = trackRef.current;
    if (track) {
      setIsOverflow(track.scrollWidth > track.clientWidth);
    }
  }, []);

  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [checkOverflow]);

  // Auto-slide only when cards overflow
  useEffect(() => {
    if (!isOverflow) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % cards.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [isOverflow]);

  const scrollTo = (index) => {
    const track = trackRef.current;
    if (!track) return;
    const cardWidth = track.children[0].offsetWidth + 24; // card width + gap
    track.scrollTo({ left: cardWidth * index, behavior: 'smooth' });
  };

  useEffect(() => {
    scrollTo(currentIndex);
  }, [currentIndex]);

  const prev = () => {
    setCurrentIndex((i) => (i === 0 ? cards.length - 1 : i - 1));
  };

  const next = () => {
    setCurrentIndex((i) => (i + 1) % cards.length);
  };

  return (
    <section className="features" id="features">
      <div className="features-header">
        <h2 className="features-title">Everything You Need to Host Amazing Events</h2>
        <p className="features-subtitle">Simple tools to make event planning effortless</p>
      </div>

      <div className="features-carousel">
        {isOverflow && (
          <button className="features-arrow features-arrow-left" onClick={prev} aria-label="Previous">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        )}

        <div className="features-track" ref={trackRef}>
          {cards.map((card, index) => (
            <div key={index} className="features-card">
              <div className="features-card-image">
                <img src={card.image} alt={card.title} />
              </div>
              <div className="features-card-body">
                <h3 className="features-card-title">{card.title}</h3>
                <p className="features-card-desc">{card.description}</p>
              </div>
            </div>
          ))}
        </div>

        {isOverflow && (
          <button className="features-arrow features-arrow-right" onClick={next} aria-label="Next">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        )}
      </div>

      {isOverflow && (
        <div className="features-dots">
          {cards.map((_, i) => (
            <button
              key={i}
              className={`features-dot ${i === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      )}
    </section>
  );
}

export default Features;
